import React from 'react'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { TH, THContainer, THead } from '../../../styles/Table.styled';
import { useTranslation } from 'react-i18next';
import CheckIcon from '@mui/icons-material/Check';
function TableHead(props) {
    const { columns, columnClickHandler, reverse, userRole, selectedAllRows, setSelectedAllRows } = props;
    const {t} = useTranslation();

    const selectAllRowsHandler = (e) => {
        setSelectedAllRows(!selectedAllRows);
    }
    return (
        <THead> 
            <tr>
             
                    <TH key={"column654"} width="50px" scope="col">
                        <THContainer style={{ justifyContent: "start" }}>
                            <CheckIcon onClick={(e) => selectAllRowsHandler(e)} />
                        </THContainer>
                    </TH>
                 
                {columns.filter(row=>row.show==true).map(column => (
                    <TH 
                        key={column.field} 
                        width={column.width}
                        scope="col" 
                        id={column.field} 
                        onClick={() => columnClickHandler(column.field, reverse)}
                    >
                        <THContainer style={{justifyContent: column?.alignSelf}}>
                            <span>
                                {column.title}
                            </span>
                            <ArrowUpwardIcon style={{fontSize: 20, display: reverse[column.field] === true ? 'block' : 'none'}} />
                            <ArrowDownwardIcon style={{fontSize: 20, display: reverse[column.field] === false ? 'block' : 'none'}}/>
                        </THContainer>    
                    </TH>
                ))}
                <TH key={"column1453"} scope="col" width="100px" >
                    <THContainer style={{ cursor: "default" }}>
                        <span>{t('tableHead:actions', 'Actions')} </span>
                    </THContainer>
                </TH>
            </tr>
        </THead>
    )
}

export default TableHead
